/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w2GXN278dkQ2gQTVQnPehW
// Component: SdMPiPjcB9G

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import Button from "../../components/widgets/Button"; // plasmic-import: SEF-sRmSoqV5c/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_plasmic_kit_data_binding.module.css"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/projectcss
import sty from "./PlasmicCopilotCodePrompt.module.css"; // plasmic-import: SdMPiPjcB9G/css

import SparklesIcon from "./icons/PlasmicIcon__Sparkles"; // plasmic-import: udef47udLQ/icon

createPlasmicElementProxy;

export type PlasmicCopilotCodePrompt__VariantMembers = {};
export type PlasmicCopilotCodePrompt__VariantsArgs = {};
type VariantPropType = keyof PlasmicCopilotCodePrompt__VariantsArgs;
export const PlasmicCopilotCodePrompt__VariantProps =
  new Array<VariantPropType>();

export type PlasmicCopilotCodePrompt__ArgsType = {};
type ArgPropType = keyof PlasmicCopilotCodePrompt__ArgsType;
export const PlasmicCopilotCodePrompt__ArgProps = new Array<ArgPropType>();

export type PlasmicCopilotCodePrompt__OverridesType = {
  root?: Flex__<"div">;
  openCopilotBtn?: Flex__<typeof Button>;
  freeBox?: Flex__<"div">;
  text?: Flex__<"div">;
  svg?: Flex__<"svg">;
};

export interface DefaultCopilotCodePromptProps {
  className?: string;
}

const $$ = {};

function PlasmicCopilotCodePrompt__RenderFunc(props: {
  variants: PlasmicCopilotCodePrompt__VariantsArgs;
  args: PlasmicCopilotCodePrompt__ArgsType;
  overrides: PlasmicCopilotCodePrompt__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
    >
      <Button
        data-plasmic-name={"openCopilotBtn"}
        data-plasmic-override={overrides.openCopilotBtn}
        caption={"Caption"}
        className={classNames("__wab_instance", sty.openCopilotBtn)}
        size={"small"}
        type={["primary", "chip"]}
      >
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox)}
        >
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text
            )}
          >
            {"Generate design"}
          </div>
          <SparklesIcon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames(projectcss.all, sty.svg)}
            role={"img"}
          />
        </div>
      </Button>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "openCopilotBtn", "freeBox", "text", "svg"],
  openCopilotBtn: ["openCopilotBtn", "freeBox", "text", "svg"],
  freeBox: ["freeBox", "text", "svg"],
  text: ["text"],
  svg: ["svg"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  openCopilotBtn: typeof Button;
  freeBox: "div";
  text: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCopilotCodePrompt__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCopilotCodePrompt__VariantsArgs;
    args?: PlasmicCopilotCodePrompt__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicCopilotCodePrompt__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicCopilotCodePrompt__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCopilotCodePrompt__ArgProps,
          internalVariantPropNames: PlasmicCopilotCodePrompt__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicCopilotCodePrompt__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCopilotCodePrompt";
  } else {
    func.displayName = `PlasmicCopilotCodePrompt.${nodeName}`;
  }
  return func;
}

export const PlasmicCopilotCodePrompt = Object.assign(
  // Top-level PlasmicCopilotCodePrompt renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    openCopilotBtn: makeNodeComponent("openCopilotBtn"),
    freeBox: makeNodeComponent("freeBox"),
    text: makeNodeComponent("text"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicCopilotCodePrompt
    internalVariantProps: PlasmicCopilotCodePrompt__VariantProps,
    internalArgProps: PlasmicCopilotCodePrompt__ArgProps,
  }
);

export default PlasmicCopilotCodePrompt;
/* prettier-ignore-end */
